 


<template>
  <div style=" 
    height: 100vh;
    left: 0;
    position: fixed;
    top: 0;
    width: 100vw;
    z-index:3"
    :style="{ backgroundColor: bg }">

    <v-container grid-list-xl>
    	 <v-layout
		      flex-child
		      wrap
		      class="justify-center"
		      style="margin-bottom:-8vh"
		    >	
		      <v-flex
		        xs12
		        md10
		        d-flex
		        offset-sm1
		      >
		      <h3 style="display:block">Explore our products</h3>
		    </v-flex>
		  </v-layout>

	    <v-layout
	      flex-child
	      wrap
	      class="justify-center"
	      style="padding-top:8vh"
	    >	
	    	
	    	
	      <v-flex
	        xs12
	        md10
	        d-flex
	        offset-sm1
	      >
	        <v-layout wrap>
	          
	         
	          <v-flex xs6 md3>
	            <v-sheet
	              class="d-flex"
	              style="border-radius:30px; cursor:pointer"
	              
	              height="130"
	              width="130"
	            >
	            <img @click="startCreate('token')" height="130px" src="../assets/contractTabSelect/TOKEN-@2x.png">
	            </v-sheet>
	            <span style="margin-top:6px;display:block" class="subheading">Token integration</span>
	          </v-flex >
			  <v-flex xs6 md3>
	            <v-sheet
	              class="d-flex"
	              style="border-radius:30px; cursor:pointer"
	              
	              height="130"
	              width="130"
	            >
	            <a href="https://smartcheck.com.au"><img  height="130px" src="../assets/contractTabSelect/SMARTCHECK-@2x.png"></a>
	            </v-sheet>
	            <span style="margin-top:6px;display:block" class="subheading">SmartCheck document platform</span>
	          </v-flex >
	          <!-- <v-flex style="opacity: 0.4; filter: alpha(opacity=40);" xs6 md3>
	            <v-sheet
	              class="d-flex"
	              style="border-radius:30px;"
	              color="yellow lighten-3"
	              height="120"
	              width="130"
	            >
	            <img @click="startCreate('nft')" height="120px" src="../assets/contractTabSelect/nft.png">
	            </v-sheet>
	            <span style="margin-top:6px;display:block" class="subheading">Digital asset</span>
	          </v-flex> -->
	          <!-- <v-flex style="opacity: 0.4; filter: alpha(opacity=40);" xs6 md3>
	            <v-sheet 
	              disabled
	              class="d-flex"
	              style="border-radius:30px;"
	               
	              height="115"
	              width="130"
	             >
 	             
	            
	            <img   height="120px" src="../assets/contractTabSelect/db.png">
	            </v-sheet>
	            <span style="margin-top:6px;display:block" class="subheading">Database</span>
	          </v-flex> -->
	          <!-- <v-flex xs6 md3 style="opacity: 0.4; filter: alpha(opacity=40);">
	            <v-sheet
	              class="d-flex"
	              color="transparent"
	              height="120"
	              
	              width="120"
	            >
	            @click="startCreate('blank')" 
	              <span  style="border: dashed 2px gray; border-radius:30px;">
	                <span style="position:relative;left:44px; top:28px" flat class="margin:auto"><span style="font-size:40px">+</span></span>
	              </span>
	            </v-sheet>
	            <span style="margin-top:6px;display:block" class="subheading">Bring your own</span>
	          </v-flex> -->
	        </v-layout>
	      </v-flex>
	    </v-layout>

	    <!--  -->


	    <v-layout row>
		    <v-flex xs12 sm10 offset-sm1>
		       

		        <v-list two-line subheader>

		          <v-list-tile
		            v-for="item in items"
		            :key="item.title"
		            @click="startCreate(item.route)"
		            avatar
		            
		          >
		            <v-list-tile-avatar>
		              <v-icon :class="[item.iconClass]">{{item.icon}}</v-icon>
		            </v-list-tile-avatar>

		            <v-list-tile-content>
		              <v-list-tile-title>{{ item.title }}</v-list-tile-title>
		              <v-list-tile-sub-title>{{ item.subtitle }}</v-list-tile-sub-title>
		            </v-list-tile-content>

		            <v-list-tile-action>
		              <v-btn style="color:silver" icon ripple>
		                <v-icon>info</v-icon>
		              </v-btn>
		            </v-list-tile-action>
		          </v-list-tile>
		           <v-list-tile
		            v-for="item in items2"
		            :key="item.title"
		            href="https://www.smartcheck.com.au/"
		            avatar
		            
		          >
		            <v-list-tile-avatar>
		              <v-icon :class="[item.iconClass]">{{item.icon}}</v-icon>
		            </v-list-tile-avatar>

		            <v-list-tile-content>
		              <v-list-tile-title>{{ item.title }} <v-icon class="launch"></v-icon></v-list-tile-title>
		              <v-list-tile-sub-title>{{ item.subtitle }}</v-list-tile-sub-title>
		            </v-list-tile-content>

		            <v-list-tile-action>
		              <v-btn style="color:silver" icon ripple>
		                <v-icon>info</v-icon>
		              </v-btn>
		            </v-list-tile-action>
		          </v-list-tile>
		        </v-list>
		       
		    </v-flex>
		  </v-layout>
		  <!--  -->
	  </v-container>
	  <div style="position:fixed; top:40px; right:100px; width:40px; height:40px">
	  	<v-btn to="/myContracts" round flat style="font-weight:600; color:gray">x</v-btn>
	  </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
    computed: {
        ...mapState({
            isDark: state => state.util.isDark
        })

    },
    data () {
      return {
        bg: 'black',
        items: [
          { icon: 'toll', iconClass: 'grey lighten-1 white--text', title: 'Token', subtitle: 'Build an economy in your application or simply commit data to the blockchain for security', route: "token" }

          
        ],
        items2: [
          // { icon: 'collections', iconClass: 'grey lighten-1 white--text', title: 'Digital asset', subtitle: 'Create unique itmes that represent digital content or real world items', route: "nft" },
          // { icon: '.', iconClass: 'grey lighten-1 white--text', title: 'Database', subtitle: 'Create your censorship resistant endpoints', route: "database" },
          { icon: 'file_copy', iconClass: 'grey lighten-1 white--text', title: 'SmartCheck', subtitle: 'Document verification platform', route: "smartcheck" },
        ]
      }
    },
    created: function () {
    	if (this.isDark) {
    		this.bg = 'black'
    	} else {
    		this.bg = 'white'
    	}
    },
    methods: {
      // openTemplates() {
      //   router.push("contractTemplates")
      // },
      startCreate(route){
      	this.$router.push({name: 'contractTemplate', params: { contractType: route }})
      	// this.$router.push("contractTemplate")
      }
    }
}
</script>


<style>
a {
	text-decoration: none !important;
}
 

</style> 
 